import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface IModal {
  icon?: string
  content: string | ReactElement
  handleClickCancel?: () => void
  handleClickContinue: () => void
  cancelMessage?: string | ReactElement
  saveMessage?: string
  textContentCenter?: boolean
  isIcon?: boolean
  header?: ReactElement
  isFooter?: boolean
  footerBtnCenter?: boolean
}

const Modal = ({
  content,
  handleClickCancel,
  handleClickContinue,
  cancelMessage,
  saveMessage,
  textContentCenter,
  icon = 'info',
  isIcon = true,
  header,
  isFooter = true,
  footerBtnCenter
}: IModal) => {
  const { t } = useTranslation()
  return (
    <div data-testid="mg-modal-overlay" className="mg-modal-overlay">
      <div className="mg-modal-deprecated">
        {header}
        <div className="mg-modal-deprecated__content">
          {isIcon && (
            <div className="mg-modal-deprecated__content__icon">
              <span className="material-icons-outlined notranslate">{icon}</span>
            </div>
          )}
          <div className={`mg-modal-deprecated__content__text ${textContentCenter ? 'text-center' : ''}`}>
            {content}
          </div>
        </div>
        {isFooter && (
          <div className={`mg-modal-deprecated__footer ${footerBtnCenter ? 'modal-footer-center' : ''}`}>
            {handleClickCancel && (
              <button
                type="button"
                data-testid="modal-cancel-button"
                className="vtmn-btn vtmn-btn_variant--secondary vtmn-btn_size--small"
                onClick={handleClickCancel}
              >
                {cancelMessage || t('cancel')}
              </button>
            )}
            <button
              type="button"
              data-testid="modal-continue-button"
              className="vtmn-btn vtmn-btn_size--small"
              onClick={handleClickContinue}
            >
              {saveMessage || t('confirmation.continue')}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Modal
